<template>
  <footer :style="{padding: '20px'}">
    <ul
      :style="{
        backgroundColor: 'var(--main-dark)',
        borderRadius: '14px',
        width: '100%',
      }"
      class="row-center"
    >
      <li
        :key="tab.id"
        v-for="tab in tabs"
        @click="setScreen(tab.screen)"
        :style="{
          width: 'calc(100% / 5)',
          paddingTop: '19px',
          paddingBottom: '19px',
          borderRadius: '14px',
        }"
        class="center clickable"
      >
        <component :is="tab.icon" />
      </li>
    </ul>
  </footer>
</template>

<script setup>
import {computed} from 'vue';
import {useStore} from 'vuex';

import {tabRoutes} from '@/routes';
import {MoreSvg} from '@/assets/svg';
import {WalletSvg} from '@/assets/svg';
import {CategorySvg} from '@/assets/svg';
import {PercentageSvg} from '@/assets/svg';
import {NotificationSvg} from '@/assets/svg';

const tabs = [
  {
    id: 1,
    screen: tabRoutes.DASHBOARD,
    icon: CategorySvg,
  },
  {
    id: 2,
    screen: tabRoutes.DEPOSITS,
    icon: WalletSvg,
  },
  {
    id: 3,
    screen: tabRoutes.LOANS,
    icon: PercentageSvg,
  },
  {
    id: 4,
    screen: tabRoutes.NOTIFICATIONS,
    icon: NotificationSvg,
  },
  {
    id: 5,
    screen: tabRoutes.MORE,
    icon: MoreSvg,
  },
];

const store = useStore();
const currentScreen = computed(() => store.getters['tab/screen']);

const setScreen = (newScreen) => {
  store.dispatch('tab/setScreen', newScreen);
};
</script>
